
export default {
  name: 'ComparisonMobileContentSection',

  props: {
    data: {
      type: Array,
      default: () => [],
      required: true,
    },
  },

  data() {
    return {
      details: this.data,
    };
  },

  computed: {
    rowDetails() {
      if (!this.details[0]) return null;
      // console.debug("details:", this.details);
      const returnObj = this.details[0].keyValues.map((_, index) => {
        const currentKey = _?.key;
        const currentDuplicatedKey = _?.handleDuplicatedKey;
        // console.log(currentDuplicatedKey)
        return this.details.map((detail) => {
          const filtered = detail.keyValues.filter((value) => value?.key === currentKey);
          // console.debug(filtered);
          // special handling for duplicated keys in wlci
          if (filtered.length > 1) {
            return filtered[currentDuplicatedKey];
          }
          if (filtered.length < 2) {
            return filtered[0];
          }
          return null;
        });
      });
      // console.debug("after mapping:", returnObj);
      return returnObj;
    },
  },

  watch: {
    data(newVal) {
      this.details = newVal;
    },
  },

  methods: {
    toggleItemActive(index) {
      const currentValue = this.rowDetails[index][0].expanded;
      this.$emit('sync-expandable', {
        innerIndex: index,
        newValue: !currentValue,
      });
    },
  },
};
